import { request } from "../../../config/helpers/axios-instance";


const GetAllQuotations = (params, queryParams) => {
    return request({
        url: `quotation/admin${queryParams}`,
        method: "GET",
        params:
            params
    })
}

export default GetAllQuotations;
